export function getAge(date_of_birth: string) {
  var today = new Date();
  var birthDate = new Date(date_of_birth);
  var age = today.getFullYear() - birthDate.getFullYear();
  var m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  return age > 17;
}
